import React, {useEffect, useState} from "react";
import PropTypes, {InferProps} from "prop-types";
import {currentPerson, usePerson, usePrincipal} from "@betrue/front/services";
import {Person, Role, Scope} from "@betrue/shared/interfaces";
import {UserModalForm} from "./add-user.form";
import {AddUserView} from "./add-user.view";
import {PROFILE_ROUTE} from "../help/routes";

export const AddUserPropsTypes = {
  openModalLabel: PropTypes.string,
  dialogTitle: PropTypes.string,
  dialogDescription: PropTypes.string,
  dialogSubmit: PropTypes.string,
  dialogCancel: PropTypes.string,
  firstNameLabel: PropTypes.string,
  lastNameLabel: PropTypes.string,
  emailLabel: PropTypes.string
}

export type AddUserProps = InferProps<typeof AddUserPropsTypes>


export const AddUser = (props: AddUserProps) => {
  const [principal] = usePrincipal()
  const [person, {getPersonById, createOfflinePerson}] = usePerson<Person>()
  const [openModal, setOpenModal] = useState<boolean>(false)

  useEffect(() => {
    if (person) {
      window.location.href = `${PROFILE_ROUTE}subjectId=${person.id}&&subject=${person.__typename}`
    }

  }, [person])

  const openCloseModal = () => {
    setOpenModal(!openModal)
  }


  const handleSubmit = (form: UserModalForm) => {
    createOfflinePerson(form.firstName, form.lastName, form.email)
    setOpenModal(false)
  }


  if (!principal) return (<></>)

  return (<>
      {principal.role === Role.ADMIN ? (
        <AddUserView {...props}
                     enabled={([Scope.EMPLOYEE].includes(principal.scope))}
                     currentPerson={principal}
                     onSubmit={handleSubmit}
                     onCloseModal={openCloseModal}
                     isOpen={openModal}
                     onOpenModal={openCloseModal}/>) : ''}

    </>
  );
}


AddUser.propTypes = AddUserPropsTypes
